"use client"
/* */
import { useOverlayContext } from './context.mjs';
import { OverlayController } from './OverlayController.mjs';
import { useEffect } from 'react';

const useOverlayController = (overlayType, opts = {}) => {
  const {
    reuseControllerFromContext = true,
    isDefaultOpen,
    onOpen,
    onClose
  } = opts;
  const newController = OverlayController.useNew({
    isDefaultOpen,
    onOpen,
    onClose
  });
  const controllerFromContext = useOverlayContext()[overlayType];
  const controller = reuseControllerFromContext && controllerFromContext ? controllerFromContext : newController;
  useEffect(() => {
    const disposers = [];
    if (onOpen) {
      disposers.push(controller.addOnOpen(onOpen));
    }
    if (onClose) {
      disposers.push(controller.addOnClose(onClose));
    }
    return () => {
      disposers.forEach((dispose) => dispose());
    };
  }, [onOpen, onClose]);
  return controller;
};

export { useOverlayController };
//# sourceMappingURL=useOverlayController.mjs.map
